import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    CODE: 'catalog.code',
    CONFIG: 'catalog.config',
    HAS_CHILDREN: 'catalog.hasChildren',
    LABEL: 'catalog.label',
    STATUS: 'catalog.status',
    TARGET: 'catalog.target',
  },
}

export const PATHS = {
  CODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CODE],
  CONFIG: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONFIG],
  HAS_CHILDREN: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.HAS_CHILDREN],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  TARGET: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TARGET],
}

export default {
  ...CONSTANTS,
  PATHS,
}
